<template>
    <span v-if="gsm == null || gsm == 'undefined'">
        _
    </span>
    <span v-else-if="!Number.isInteger(gsm)">
        {{ gsm }}
    </span>
    <span v-else-if="gsm >= 60" class="ui-badge status-badge--ok">
        <font-awesome-icon :icon="['fas', 'signal']" class="me-1"/> {{ 5*gsm/100 }} / 5
    </span>
    <span v-else-if="gsm >= 20" class="ui-badge status-badge--medium">
        <font-awesome-icon :icon="['fas', 'signal']" class="me-1"/> {{ 5*gsm/100 }} / 5
    </span>
    <span v-else class="ui-badge status-badge--low">
        <font-awesome-icon :icon="['fas', 'signal']" class="me-1"/> {{ 5*gsm/100 }} / 5
    </span>
</template>

<script>
export default {
  props: ['gsm']
}
</script>